<template>
  <div class="app-contain">
    <div class="bkg-img">
      <div class="light-bkg"></div>
    </div>

    <UnderConstruction />
  </div>
</template>

<script>
import UnderConstruction from './components/UnderConstruction.vue'

export default {
  name: 'App',
  components: {
    UnderConstruction
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  margin: 0px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.app-contain {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  z-index: 0;

  .bkg-img {
    width: 100%;
    height: 100vh;
    background-image: url('../public/images/natural-product.jpg');
    background-size: cover;
    position: absolute;
    filter: blur(4px);
    z-index: -1;

    .light-bkg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(255,255,255,0.7);
    }
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .app-contain {

    .bkg-img {
      background-position: 50%;
    }
  }
}
</style>
